/**
 * Idle session configuration.
 * Prefer values from GET /auth/session-policy; env vars are fallbacks.
 */
export const DEFAULT_IDLE_TIMEOUT_MS =
  Number(process.env.REACT_APP_IDLE_TIMEOUT_MS) || 20 * 60 * 1000;

export const DEFAULT_IDLE_WARNING_LEAD_MS =
  Number(process.env.REACT_APP_IDLE_WARNING_MS) || 60 * 1000;

/** Absolute hard max from login (legacy fallback; server policy overrides). */
export const ABSOLUTE_SESSION_TTL_MS =
  Number(process.env.REACT_APP_SESSION_TTL_MS) || 8 * 60 * 60 * 1000;

export const DEFAULT_ACCESS_TOKEN_MS =
  Number(process.env.REACT_APP_ACCESS_TOKEN_MS) || 30 * 60 * 1000;

let runtimePolicy = {
  idleTimeoutMs: DEFAULT_IDLE_TIMEOUT_MS,
  warningLeadMs: DEFAULT_IDLE_WARNING_LEAD_MS,
  absoluteTimeoutMs: ABSOLUTE_SESSION_TTL_MS,
  accessTokenExpirationMs: DEFAULT_ACCESS_TOKEN_MS,
};

export function getIdleSessionPolicy() {
  return { ...runtimePolicy };
}

export function setIdleSessionPolicy(partial = {}) {
  runtimePolicy = {
    idleTimeoutMs: Number(partial.idleTimeoutMs) || runtimePolicy.idleTimeoutMs,
    warningLeadMs: Number(partial.warningLeadMs) || runtimePolicy.warningLeadMs,
    absoluteTimeoutMs: Number(partial.absoluteTimeoutMs) || runtimePolicy.absoluteTimeoutMs,
    accessTokenExpirationMs:
      Number(partial.accessTokenExpirationMs) || runtimePolicy.accessTokenExpirationMs,
  };
  return getIdleSessionPolicy();
}
